import { isUndefined } from 'lodash';

import { formatBytes } from '@air/utilities';

export const getSubtitleWithProgress = ({
  sizeInBytes,
  title,
  uploadedBytes,
}: {
  uploadedBytes?: number;
  sizeInBytes?: number;
  title: string;
}) => {
  if (sizeInBytes && !isUndefined(uploadedBytes)) {
    return `${title} · ${formatBytes(uploadedBytes ?? 0, {
      numberOfDecimals: 2,
    })}\u202f/\u202f${formatBytes(sizeInBytes, {
      numberOfDecimals: 2,
    })}`;
  }

  return title;
};
